import PropTypes from 'prop-types';
/* eslint-disable react/prop-types */
import React from 'react';

import fallBackPoster from '../../assets/placeholder.jpg';
import { audioPlugins, videoPlugins } from '../../plugins';
import { isMobile } from '../../util/mobile-detect';
import { BNNVARAMediaPlayer } from '../BNNVARAMediaPlayer/BNNVARAMediaPlayer';
import { NPOVideoPlayer } from '../NPOVideoPlayer/NPOVideoPlayer';
import { AUDIO_TYPE, VIDEO_TYPE } from './types';

export const MediaPlayer = ({
  embedId,
  type,
  source,
  poster,
  title,
  programTitle,
  subtitles,
  genres,
  broadcasters,
  mediaId,
  classifications,
  duration,
  cta,
  isBroadcastEnabled,
  userId,
  isFallback,
}) => {
  /**
   * Render NPO player
   */
  if (embedId) {
    return (
      <NPOVideoPlayer
        type={type}
        title={title}
        embedId={embedId}
        isBroadcastEnabled={isBroadcastEnabled}
      />
    );
  }

  /**
   * Render remaining types Video and Audio
   */
  const searchParams = new URLSearchParams(window.location.search);
  const vertical = !!searchParams.get('vertical');

  return (
    <BNNVARAMediaPlayer
      cta={cta}
      mediaId={mediaId}
      vertical={vertical}
      source={source}
      duration={duration}
      poster={poster}
      loadingPosterImage={type === VIDEO_TYPE ? fallBackPoster : null}
      isMobile={isMobile()}
      title={title}
      programTitle={programTitle}
      subtitles={subtitles}
      broadcasters={broadcasters}
      plugins={type === AUDIO_TYPE ? audioPlugins : videoPlugins}
      genres={genres}
      classifications={classifications}
      type={type === AUDIO_TYPE ? 'audio' : 'video'}
      userId={userId}
      isFallback={isFallback}
    />
  );
};

MediaPlayer.defaultProps = {
  isFallback: false,
};

MediaPlayer.propTypes = {
  type: PropTypes.oneOf([VIDEO_TYPE, AUDIO_TYPE]).isRequired,
  isFallback: PropTypes.bool,
  embedId: PropTypes.string,
  source: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      type: PropTypes.string,
      name: PropTypes.string,
      ratio: PropTypes.string,
    })
  ),
  poster: PropTypes.string,
  title: PropTypes.string,
  programTitle: PropTypes.string,
  subtitles: PropTypes.arrayOf(
    PropTypes.shape({
      kind: PropTypes.string,
      src: PropTypes.string,
      label: PropTypes.string,
      default: PropTypes.bool,
    })
  ),
  genres: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  broadcasters: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
    })
  ),
  mediaId: PropTypes.string.isRequired,
  classifications: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      imageUrl: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  duration: PropTypes.number,
  cta: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
  isBroadcastEnabled: PropTypes.bool,
  userId: PropTypes.string,
};
